<template>
    <div class="row">
        <div class="card mt-5 col-12 p-0">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">{{ $t('userManagement.title') }}</div>
            </div>
            <div class="card-body">
                <div class="loader" v-if="loadingUsers"></div>
                <div v-if="!loadingUsers">
                    <div class="form-group">
                        <kendo-dropdownlist v-model="selectedUserId"
                                            :data-source="users"
                                            :data-text-field="'email'"
                                            :data-value-field="'id'"
                                            :optionLabel="$t('choose')"
                                            :filter="'contains'"
                                            style="width: 100%;">
                        </kendo-dropdownlist>
                    </div>
                    <div v-if="selectedUserId">
                        <div class="loader" v-if="loadingRoles"></div>
                        <div v-if="!loadingRoles">
                            <kendo-multiselect v-model="selectedRoles"
                                               :data-source="roles"
                                               :name="'dropdown' + _uid"
                                               style="width: 100%;">
                            </kendo-multiselect>
                        </div>
                    </div>
                    <div class="text-center" v-if="!loading && !loadingRoles && !loadingUsers && selectedUserId">
                        <button v-if="hasEditRights" type="button" class="btn btn-primary btn mt-2" @click="save" :disabled="loading">
                            <i class="fas fa-save"></i>
                            {{ $t('buttons.save.btnText') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import actionLogService from "@/services/actionLog.service"

    export default {
        data () {
            return {
                loading: false,
                loadingUsers: false,
                loadingRoles: false,
                saving: false,
                selectedUserId: null,
                selectedUser: null,
                users: [],
                roles: [],
                selectedRoles: [],
            }
        },
        methods: {
            loadUsers() {
                this.loadingUsers = true;
                this.$http.get(`/api/User/GetUsers`)
                    .then(response => {
                        this.users = response.data;
                        this.selectedRoles = response.data.roles;
                        this.loadingUsers = false;
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.loading = false });
            },
            loadRoles() {
                this.loadingRoles = true;
                this.$http.get(`/api/Roles/GetAll`)
                    .then(response => {
                        this.roles = response.data;
                        this.loadingRoles = false;
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.loading = false });
            },
            save() {
                if (!this.hasEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.saving = true;
                this.$http.post('/api/User/ChangeUserRoles', {
                    userId: this.selectedUserId,
                    roles: this.selectedRoles
                }).then(() => {
                    this.loading = false;
                    this.selectedUser.roles = this.selectedRoles;

                    actionLogService.userRolesChange(this.selectedUserId);

                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.errorDataNotSaved'),
                        position: 'top-center',
                        color: 'danger'
                    });
                })
            },
        },
        watch: {
            selectedUserId(newValue, oldValue) {
                for (let user of this.users) {
                    if (user.id === this.selectedUserId) {
                        this.selectedRoles = user.roles;
                        this.selectedUser = user;
                        break;
                    }
                }
            }
        },
        mounted () {
            this.loadUsers();
            this.loadRoles();
        },
        computed: {
            hasEditRights() {
                return this.$store.getters.claims.aspNetUser.create
                    || this.$store.getters.claims.aspNetUser.update;
            },
        }
    }
</script>

<style scoped>
</style>
